import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLayoutPlanQuery } from "../../store/Features/settings/layoutPlan-api-slice"

import { useSelector } from "react-redux"
import { IDeviceList } from "types/IDeviceList"
import { ILayoutPlan, ISelectedDeviceIds } from "@types"

import { useDeviceListMutation } from "../../store/Features/devices/deviceList-api-slice"

export const SitePlan = () => {
 const { t } = useTranslation("translation")
 const { data: newData } = useLayoutPlanQuery()
 const selectedDeviceIds: ISelectedDeviceIds = useSelector((state: any) => state.selectedDevicesIds)

 const [deviceList] = useDeviceListMutation()
 const [selectedDevice, setSelectedDevice] = useState<ILayoutPlan[] | undefined>([])
 const [currentIndex, setCurrentIndex] = useState<number>(0)
 const [signalData, setSignalData] = useState<any>()

 useEffect(() => {
  let socket: WebSocket

  function connectSocket() {
   // Token obtained from cookie
   // const token = cookie.load("token")

   //Hard-coded token
   const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoid2Vic29ja2V0IiwicGFzc3dvcmQiOiJ0ZXN0In0.Qeibok6YCameSeRIL_nzmmkWLd0MHJrakNsw7wWcC5E"

   socket = new WebSocket(
    `${process.env.REACT_APP_WEBSOCKET_URL}/devices/ws/layout_plan?token=${token}`,
   )

   socket.onopen = function (event) {
    console.log("connected!!!", event)
    // Check if selectedDevice and device_id are available before sending the message
    if (selectedDevice && selectedDevice[currentIndex]?.common_information?.device_id) {
     sendMessage()
    } else {
     console.log("Selected device ID is not available yet.")
    }
   }

   socket.onmessage = function (event) {
    // Handle received message
    const eventData = JSON.parse(event.data)
    // Transform and process data...
    handleEventData(eventData)
   }

   socket.onclose = function (event) {
    console.log("disconnected!!!", event)
   }
  }

  function sendMessage() {
   socket.send(
    JSON.stringify({
     action: "requestUpdate",
     device_id: selectedDevice && selectedDevice[currentIndex]?.common_information?.device_id,
    }),
   )
  }

  function handleEventData(eventData: any) {
   // Transforming signal_values array
   const updatedData = {
    updates: {
     ...eventData.updates,
     data: eventData.updates.data.map((item: any) => ({
      ...item,
      signal_values: item.signal_values.map((entry: any) => ({
       ocit_outstation_number: parseInt(Object.keys(entry)[0]),
       status: "#" + (parseInt(entry[Object.keys(entry)[0]]) >>> 0).toString(2).padStart(8, "0"), // Convert status to 8-digit binary directly
      })),
      detector_values: item.detector_values
       ? item.detector_values.map((entry: any) => ({
          ocit_outstation_number: parseInt(Object.keys(entry)[0]),
          status: "#" + (parseInt(entry[Object.keys(entry)[0]]) >>> 0).toString(2).padStart(8, "0"), // Convert status to 8-digit binary directly
         }))
       : [],
     })),
    },
   }
   // Update state or perform further processing
   setSignalData(updatedData)
  }

  connectSocket() // Initial connection

  return () => {
   console.log("Closing WebSocket connection...")
   socket.close()
  }
 }, [currentIndex, selectedDevice && selectedDevice[currentIndex]])

 useEffect(() => {
  if (Array.isArray(newData) && selectedDeviceIds?.deviceIds) {
   deviceList({ deviceId: selectedDeviceIds.deviceIds })
    .then((res: any) => {
     const matchingDeviceIds = res.data.map((device: IDeviceList) => device.device_id)

     const filteredData = newData.filter((newDevice: ILayoutPlan | undefined) => {
      const deviceId = newDevice?.common_information?.device_id
      return deviceId !== undefined && matchingDeviceIds.includes(deviceId)
     })

     setSelectedDevice(filteredData)
    })
    .catch((e) => {
     console.log("e", e)
    })
  }
 }, [newData, selectedDeviceIds])

 return (
  <div className="w-[96%] mx-auto pt-6">
   <h1 className="Jakarta-font font-semibold">{t("sitePlan")}</h1>

   <div className="w-full mb-4">
    <ul className="flex w-full Jakarta-font mt-6 overflow-x-auto hide-scroll-icon">
     {selectedDevice &&
      selectedDevice.map((single, index) => (
       <li
        onClick={() => setCurrentIndex(index)}
        key={index}
        className={`text-xs opacity-70 cursor-pointer rounded py-3 text-black px-2 ${
         index === currentIndex ? "bg-golden text-white" : "bg-light-gray2"
        }`}
       >
        {single?.common_information?.device_name}
       </li>
      ))}
    </ul>
   </div>

   <div className="w-full">
    {selectedDevice && selectedDevice[currentIndex]?.signal_plan && (
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="847"
      height="500"
      version="1.1"
      viewBox="0 0 847 500"
     >
      <image href={`data:image/jpeg;base64,${selectedDevice[currentIndex]?.signal_plan?.data}`} />

      {selectedDevice[currentIndex]?.signal_group_list &&
       selectedDevice[currentIndex]?.signal_group_list?.map((group, groupIndex) => {
        const liveItem =
         signalData?.data &&
         signalData.data[0].signal_values.find(
          (item: any) => item.ocit_outstation_number === group.ocit_outstation_number,
         )

        return (
         <polygon
          key={`signal_group_${groupIndex}`}
          points={group.polygons.map((point) => `${point.x_coord},${point.y_coord}`).join(" ")}
          fill={liveItem?.status}
          stroke="#808080"
          strokeWidth="2"
         />
        )
       })}

      {selectedDevice[currentIndex].detector_group_list &&
       selectedDevice[currentIndex]?.detector_group_list?.map((group, groupIndex) => {
        const liveItem =
         signalData?.data &&
         signalData.data[0].detector_values.find(
          (liveItem: any) => liveItem.ocit_outstation_number === group.ocit_outstation_number,
         )

        return (
         <polygon
          key={`detector_group_${groupIndex}`}
          points={group.polygons.map((point: any) => `${point.x_coord},${point.y_coord}`).join(" ")}
          fill={liveItem?.status}
          stroke="#808080"
          strokeWidth="2"
         />
        )
       })}
     </svg>
    )}
   </div>
  </div>
 )
}
